import { connect } from 'react-redux';
import EntityName from '../../components/EntityName';

export default connect(
    (state, {id}) => ({
        name: state.entities[id].name
    }),
    {}
)(EntityName);